import WeatherList from "./weather-list";

export default WeatherList;
